module.exports = __webpack_public_path__ + "static/img/lixianrenwu.6380c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/lixianrenwu.png
// module id = I4rf
// module chunks = 24